import batchNumberSelection from './batchNumberSelection.vue'
export default batchNumberSelection
